import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";

import edit from "../../../images/edit.svg";
import Delete from "../../../images/delete.svg";
import Logo from "../../../images/logo-2.png";
import { useSelector } from "react-redux";
import api from "../../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "../loader";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { Edit2, Trash2 } from "lucide-react";

export function AdminGodzilla({ match, title = "Godzilla Signal" }) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfPost, setnoOfPost] = useState(0);
  const [loader, setLoader] = useState(true);
  const [tradeStats, setTradeStats] = useState(null);
  const [prices, setPrices] = useState({});
  const [hasOpenTrades, setHasOpenTrades] = useState(false);
  const [timeFrame, setTimeFrame] = useState("4h");

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [selectedData, setSelectedData] = useState({});

  const [showEdit, setShowEdit] = useState(false);
  const handleCloseEdit = () => setShowEdit(false);
  const handleShowEdit = (item) => {
    setSelectedData(item);
    setShowEdit(true);
  };

  const getPosts = async () => {
    try {
      setLoader(true);
      const [postData, statsData] = await Promise.all([
        api.getGodzillaByAdmin({ page }),
        api.getGodzillaStats(),
      ]);
      setData(postData.trades);
      setnoOfPost(postData.total);
      setLimit(postData.limit);
      setPrices(postData?.prices);
      setTradeStats(statsData);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const deletePost = async (id) => {
    try {
      let payload = {
        id: id,
      };
      setLoader(true);
      const isConfirmed = window.confirm(
        "Are you sure you want to delete this item?",
      );
      if (isConfirmed) {
        const userData = await api.godzillaDelete(payload);
        console.log("deleted");
        getPosts();
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    getPosts();
  }, [page]);

  const s = tradeStats || {};
  const overall = s.overall || {};
  const h24 = s.last24h || {};

  return (
    <>
      {/* Begin Page Content */}
      <div className="container-fluid modern-admin-container">
        {/* Page Header */}
        <div className="modern-page-header">
          <div className="header-content">
            <div className="title-container">
              <h1 className="modern-page-title">{title}</h1>
            </div>
          </div>
        </div>

        {/* ── ALL TIME stats ── */}
        <p className="gz-section-label">ALL TIME</p>
        <div className="gz-stats-grid">
          {[
            {
              icon: "fa-newspaper",
              color: "#6366f1",
              val: overall.total || 0,
              label: "Total Signals",
            },
            {
              icon: "fa-bullseye",
              color: "#10b981",
              val: overall.targetHit || 0,
              label: "Target Hit",
            },
            {
              icon: "fa-shield-alt",
              color: "#ef4444",
              val: overall.stopLoss || 0,
              label: "Stop Loss Hit",
            },
            {
              icon: "fa-clock",
              color: "#f59e0b",
              val: overall.timeExpired || 0,
              label: "Time Expired",
            },
            {
              icon: "fa-lock-open",
              color: "#3b82f6",
              val: overall.open || 0,
              label: "Open Trades",
            },
            {
              icon: "fa-check-circle",
              color: "#6b7280",
              val: overall.closed || 0,
              label: "Closed Trades",
            },
            {
              icon: "fa-arrow-trend-up",
              color: "#10b981",
              val: overall.closedInProfit || 0,
              label: "Closed In Profit",
            },
            {
              icon: "fa-arrow-trend-down",
              color: "#ef4444",
              val: overall.closedInLoss || 0,
              label: "Closed In Loss",
            },
          ].map(({ icon, color, val, label }) => (
            <div key={label} className="gz-stat-card">
              <div
                className="gz-stat-icon"
                style={{ background: color + "18", color }}
              >
                <i className={`fas ${icon}`}></i>
              </div>
              <div className="gz-stat-body">
                <span className="gz-stat-value">{val}</span>
                <span className="gz-stat-label">{label}</span>
              </div>
            </div>
          ))}
        </div>

        {/* ── 24H stats ── */}
        <p className="gz-section-label" style={{ marginTop: 24 }}>
          LAST 24 HOURS
        </p>
        <div className="gz-stats-grid">
          {[
            {
              icon: "fa-newspaper",
              color: "#6366f1",
              val: h24.total || 0,
              label: "Signals",
            },
            {
              icon: "fa-bullseye",
              color: "#10b981",
              val: h24.targetHit || 0,
              label: "Target Hit",
            },
            {
              icon: "fa-shield-alt",
              color: "#ef4444",
              val: h24.stopLoss || 0,
              label: "Stop Loss",
            },
            {
              icon: "fa-clock",
              color: "#f59e0b",
              val: h24.timeExpired || 0,
              label: "Time Expired",
            },
            {
              icon: "fa-arrow-trend-up",
              color: "#10b981",
              val: h24.closedInProfit || 0,
              label: "Closed In Profit",
            },
            {
              icon: "fa-arrow-trend-down",
              color: "#ef4444",
              val: h24.closedInLoss || 0,
              label: "Closed In Loss",
            },
          ].map(({ icon, color, val, label }) => (
            <div key={label} className="gz-stat-card">
              <div
                className="gz-stat-icon"
                style={{ background: color + "18", color }}
              >
                <i className={`fas ${icon}`}></i>
              </div>
              <div className="gz-stat-body">
                <span className="gz-stat-value">{val}</span>
                <span className="gz-stat-label">{label}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Content Card */}
        <div className="modern-content-card">
          <div className="card-header-section">
            <div className="table-actions">
              {/* <div className="search-box">
                <i className="fas fa-search"></i>
                <input type="text" placeholder="Search market updates..." />
              </div> */}
              <div className="table-info">
                <span className="info-text">
                  Showing {data.length} of {noOfPost} updates
                </span>
              </div>
            </div>
          </div>

          {/* Table Container */}
          <div className="table-responsive-container">
            <Table
              data={data}
              setPage={setPage}
              page={page}
              noOfPost={noOfPost}
              limit={limit}
              deletePost={deletePost}
              handleShowEdit={handleShowEdit}
              prices={prices}
            />
          </div>
        </div>
      </div>

      {loader && <Loader />}
    </>
  );
}

const Table = ({
  data,
  page,
  setPage,
  noOfPost,
  limit,
  deletePost,
  handleShowEdit,
  prices,
}) => {
  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm a");
    return dateTemp;
  };

  function formatDecimal(value) {
    if (value === undefined || value === null) return "";
    const decimalPart = value.toString().split(".")[1];
    if (decimalPart && decimalPart.length > 4) {
      return Number(value.toFixed(4));
    }
    return value;
  }

  const MARGIN = 100;
  const LEVERAGE = 100;
  const POSITION_SIZE = MARGIN * LEVERAGE; // 10000

  const calcPnlValue = (trade, exitPrice) => {
    if (!exitPrice) return null;

    const { entryPrice, position } = trade;
    if (!entryPrice || !position) return null;

    let pnl;
    if (position === "LONG") {
      pnl = (POSITION_SIZE * (exitPrice - entryPrice)) / entryPrice;
    } else if (position === "SHORT") {
      pnl = (POSITION_SIZE * (entryPrice - exitPrice)) / entryPrice;
    } else {
      return null;
    }

    return Number(pnl.toFixed(2)); // $ value
  };

  // Helper styling for Risk Reward Statuses
  const getRrStatusClass = (status) => {
    switch (status?.toUpperCase()) {
      case "APPROVE":
        return "bg-success text-white"; // Green badge
      case "REJECT":
        return "bg-danger text-white"; // Red badge
      case "NEUTRAL":
        return "bg-warning text-dark"; // Yellow/Gold badge
      default:
        return "bg-secondary text-white"; // Gray fallback
    }
  };

  return (
    <>
      <table className="modern-table">
        <thead>
          <tr>
            <th>Coin</th>
            <th>Position</th>
            <th>Entry Price</th>
            <th>Take Profit</th>
            <th>Stop Loss</th>
            {/* 🌟 New RR Headers */}
            <th>Closed Price</th>
            <th>Status</th>
            <th>Closed Reason</th>
            <th>PNL $</th>
            <th>Opened At</th>
            <th>Closed At</th>
            <th>R:R Ratio</th>
            <th>R:R Status</th>
            <th>Image</th>
            <th>Video</th>
            <th>Voice</th>
            <th>Description</th>
            <th>Created At</th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((item, key) => (
              <tr key={key}>
                <td>
                  <div className="date-cell">{item?.coin || "-"}</div>
                </td>
                <td>
                  <div className="date-cell">{item?.position || "-"}</div>
                </td>
                <td>
                  <div className="date-cell">
                    {item?.entryPrice ? "$" + item?.entryPrice : "-"}
                  </div>
                </td>
                <td>
                  <div className="date-cell">
                    {item?.targetPrice ? "$" + item?.targetPrice : "-"}
                  </div>
                </td>
                <td>
                  <div className="date-cell">
                    {item?.stopLoss ? "$" + item?.stopLoss : "-"}
                  </div>
                </td>
                <td>
                  <div className="date-cell">
                    {item?.closedPrice ? "$" + item?.closedPrice : "-"}
                  </div>
                </td>
                <td>
                  <div className="date-cell">
                    {item?.coin ? (
                      <div
                        className={`status-badge ${
                          item?.status === "OPEN"
                            ? "status-processing"
                            : "status-closed"
                        }`}
                      >
                        {item?.status}
                      </div>
                    ) : (
                      "-"
                    )}
                  </div>
                </td>
                <td>
                  <div className="date-cell">
                    {item?.closeReason ? item?.closeReason : "-"}
                  </div>
                </td>
                <td className="table-cell">
                  {item.status === "OPEN" && prices?.[item.coin] ? (
                    <span
                      className={
                        calcPnlValue(item, prices[item.coin]) >= 0
                          ? "text-success d-flex"
                          : "text-danger d-flex"
                      }
                    >
                      ${calcPnlValue(item, prices[item.coin])}
                    </span>
                  ) : item.status === "CLOSED" && item.closedPrice ? (
                    <span
                      className={
                        calcPnlValue(item, item.closedPrice) >= 0
                          ? "text-success d-flex"
                          : "text-danger d-flex"
                      }
                    >
                      ${calcPnlValue(item, item.closedPrice) ?? 0}
                    </span>
                  ) : (
                    "-"
                  )}
                </td>
                <td>
                  <div className="date-cell">{formatDate(item?.openedAt)}</div>
                </td>
                <td>
                  <div className="date-cell">
                    {item?.closedAt ? formatDate(item?.closedAt) : "-"}
                  </div>
                </td>
                {/* 🌟 New RR Data Columns */}
                <td>
                  <div className="date-cell font-weight-bold">
                    {item?.rr !== undefined && item?.rr !== null
                      ? `${item.rr}`
                      : "-"}
                  </div>
                </td>
                <td>
                  <div className="date-cell">
                    {item?.rr_status ? (
                      <span
                        className={`status-badge ${getRrStatusClass(item.rr_status)}`}
                      >
                        {item.rr_status}
                      </span>
                    ) : (
                      "-"
                    )}
                  </div>
                </td>

                <td>
                  {item.imageTitle ? (
                    <div className="media-preview">
                      {item.imageTitle.split(",").map((val, key) => (
                        <div className="pImage" key={key}>
                          <img
                            src={`${process.env.REACT_APP_S3URL}/img_${val}.${
                              item.imageFormat.split(",")[key]
                            }`}
                            alt={`Preview ${key + 1}`}
                          />
                        </div>
                      ))}
                    </div>
                  ) : (
                    <span className="empty-cell">-</span>
                  )}
                </td>
                <td>
                  {item?.video ? (
                    <div className="iframeVideoAdmin">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item?.video,
                        }}
                      />
                    </div>
                  ) : (
                    <span className="empty-cell">-</span>
                  )}
                </td>
                <td>
                  {item?.voice ? (
                    <div className="" style={{ padding: 0, width: 230 }}>
                      <audio controls style={{ width: "100%" }}>
                        <source
                          src={`${process.env.REACT_APP_S3URLVoice}/${item.voice}`}
                        />
                        Audio element not supported by your browser.
                      </audio>
                    </div>
                  ) : (
                    <span className="empty-cell">-</span>
                  )}
                </td>

                <td>
                  <div className="description-cell">
                    {item?.description ? (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item?.description,
                        }}
                      />
                    ) : (
                      <span className="empty-cell">-</span>
                    )}
                  </div>
                </td>

                <td>
                  <div className="date-cell">
                    {item?.createdAt ? (
                      formatDate(item?.createdAt)
                    ) : (
                      <span className="empty-cell">-</span>
                    )}
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="18">
                {" "}
                {/* Updated span from 8 to 18 for full width alignment */}
                <div className="empty-state">
                  <div className="empty-icon">
                    <i className="fas fa-newspaper"></i>
                  </div>
                  <h3 className="empty-title">No Data Found</h3>
                  <p className="empty-subtitle">
                    Get started by creating your first Waqar Zaka update
                  </p>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {noOfPost > 0 && (
        <div className="pagination-container">
          <div className="d-flex justify-content-center py-4">
            <Stack spacing={2}>
              <Pagination
                count={Math.ceil(noOfPost / limit)}
                page={page}
                onChange={handleChange}
                color="primary"
                shape="rounded"
                size="medium"
              />
            </Stack>
          </div>
        </div>
      )}
    </>
  );
};
